import {PageContainerSkeleton, TableSkeleton, ToolbarSkeleton} from "@project/components/feedback";
import {offersRouteApi} from "../-route-api";

export function OffersPending() {
  const search = offersRouteApi.useSearch();
  return (
    <PageContainerSkeleton>
      <ToolbarSkeleton>
        <ToolbarSkeleton.Button />
        <ToolbarSkeleton.Actions>
          <ToolbarSkeleton.Button />
        </ToolbarSkeleton.Actions>
      </ToolbarSkeleton>
      <TableSkeleton columns={7} rows={search.perPage ?? 20} />
    </PageContainerSkeleton>
  );
}
